import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Education.css';

function Education() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const program = [
    'Терапевт — рабочее состояние',
    'Начало терапии. Формирование запроса',
    'Сбор анамнеза и выстраивание гипотезы',
    'Определение структуры психики и психологического возраста',
    'Работа с защитами, сопротивлением и копингом',
    'Слушание на нескольких уровнях: перенос, контрперенос, объектные отношения',
    'Элементы и уровни психотерапии',
    'Инструменты и интервенции',
    'Работа с патологическими чертами характера',
    'Тупиковые ситуации и завершение терапии',
  ];

  return (
    <main className="education-page">
      <div className="app-container">

        {/* ========================================
            ВЕРХНИЙ БЛОК
            ======================================== */}
        <section className="education-main">

          <div className="education-main__content">
            <span className="education-kicker">
              Образовательная программа АПП
            </span>

            <h1>
              Техника и практика психотерапии
            </h1>

            <p className="education-main__lead">
              Практический курс по основам психотерапевтической работы:
              от формирования запроса и гипотез до интервенций
              и завершения терапии.
            </p>

            <div className="education-facts">
              <div>
                <strong>Очно + онлайн</strong>
                <span>Формат обучения</span>
              </div>

              <div>
                <strong>1,5 часа</strong>
                <span>Одно занятие</span>
              </div>

              <div>
                <strong>Практика</strong>
                <span>Разборы и работа с кейсами</span>
              </div>

              <div>
                <strong>Сертификат АПП</strong>
                <span>По окончании курса</span>
              </div>
            </div>

            <a
              href="https://t.me/Fedorov_App"
              target="_blank"
              rel="noopener noreferrer"
              className="education-button"
            >
              Записаться на курс
            </a>
          </div>


          {/* ========================================
              ВЕДУЩИЙ
              ======================================== */}
          <aside className="education-teacher">

            <div className="education-teacher__photo">
              <img
                src={`${process.env.PUBLIC_URL}/images/IWF.png`}
                alt="Фёдоров Игорь Валерьевич"
              />
            </div>

            <div className="education-teacher__content">
              <span className="education-teacher__label">
                Ведущий курса
              </span>

              <h2>
                Фёдоров Игорь Валерьевич
              </h2>

              <p>
                Кандидат психологических наук, доцент ТГУ,
                основатель Ассоциации практикующих психологов,
                специалист в области психодинамической психологии.
              </p>

              <div className="education-teacher__contacts">

                <a
                  href="https://t.me/Fedorov_App"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telegram
                </a>

                <a href="tel:+79039553396">
                  +7 903 955-33-96
                </a>

              </div>
            </div>

          </aside>

        </section>


        {/* ========================================
            ПРОГРАММА
            ======================================== */}
        <section className="education-program">

          <div className="education-program__heading">
            <span className="education-kicker">
              Содержание курса
            </span>

            <h2>
              Программа
            </h2>
          </div>

          <div className="education-program__grid">

            {program.map((item, index) => (
              <article
                className="education-program__item"
                key={item}
              >
                <span>
                  {String(index + 1).padStart(2, '0')}
                </span>

                <p>
                  {item}
                </p>
              </article>
            ))}

          </div>
        </section>


        {/* ========================================
            НИЖНИЕ КНОПКИ
            ======================================== */}
        <div className="education-actions">

          <a
            href="https://t.me/Fedorov_App"
            target="_blank"
            rel="noopener noreferrer"
            className="education-button"
          >
            Записаться на курс
          </a>

          <Link
            to="/"
            className="education-button education-button--secondary"
          >
            На главную
          </Link>

        </div>

      </div>
    </main>
  );
}

export default Education;